import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import type { FC } from "react";

export type TheaterModeContextType = {
  isTheaterModeEnabled: boolean;
  enabledTheaterMode: () => void;
  disabledTheaterMode: () => void;
  toggleTheaterMode: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const TheaterModeContext = createContext<TheaterModeContextType>({
  isTheaterModeEnabled: false,
  enabledTheaterMode: noop,
  disabledTheaterMode: noop,
  toggleTheaterMode: noop,
});

type TheaterModeProviderProps = {
  isHiddenStreamingComment?: boolean;
};

export const TheaterModeProvider: FC<TheaterModeProviderProps> = ({
  children,
  isHiddenStreamingComment, //コメントを出さないイベントは常にシアターモード
}) => {
  const isForceTheaterMode = isHiddenStreamingComment ?? false;
  const [theaterModeRequested, setTheaterModeRequested] =
    useState<boolean>(false);
  const isTheaterModeEnabled = isForceTheaterMode || theaterModeRequested;
  const enabledTheaterMode = useCallback(() => {
    setTheaterModeRequested(true);
  }, [setTheaterModeRequested]);

  const disabledTheaterMode = useCallback(() => {
    setTheaterModeRequested(false);
  }, [setTheaterModeRequested]);

  const toggleTheaterMode = useCallback(() => {
    setTheaterModeRequested((prev) => !prev);
  }, [setTheaterModeRequested]);

  const contextValue = useMemo(
    () => ({
      isTheaterModeEnabled,
      isForceTheaterMode,
      enabledTheaterMode,
      disabledTheaterMode,
      toggleTheaterMode,
    }),
    [
      isTheaterModeEnabled,
      isForceTheaterMode,
      enabledTheaterMode,
      disabledTheaterMode,
      toggleTheaterMode,
    ]
  );

  return (
    <TheaterModeContext.Provider value={contextValue}>
      {children}
    </TheaterModeContext.Provider>
  );
};

export const useTheaterMode = () => {
  return useContext(TheaterModeContext);
};
